import React from 'react';
import PropTypes from 'prop-types';
import ReviewQuoteInstallationOption from './ReviewQuoteInstallationOption';
import ReviewQuoteInstallationTravel from './ReviewQuoteInstallationTravel';
import { QuoteInstallation } from '../../../quotes/otherQuoteEntities';
import { FormToggle } from '@ami/react/core';
import { Quote } from '../../../quotes/quote';
import classNames from 'classnames';

const NoOptions = ({ show }) =>
  show ? (
    <div className="text-center">
      No installation options are available for the selected products
    </div>
  ) : null;

const InstallationOptionsTable = ({
  installationOptions,
  installationTravelInstance,
  readOnly,
  msrpClassNames,
  dNetClassNames,
  selectedPriceMode,
  isoCurrencySymbol,
}) => {
  const tableClass = `table review-product-table table-mobile ${
    readOnly && 'text-secondary'
  }`;
  return (
    <table className={tableClass}>
      <thead>
        <tr>
          <th width="60%" className="text-start">
            Description
          </th>
          <th width="40%">
            <div className="row">
              <div className="col-6"></div>
              <div className={classNames(msrpClassNames, 'text-end')}>MSRP</div>
              <div className={classNames(dNetClassNames, 'text-end')}>
                D. NET
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {installationOptions.map((installationOption) => (
          <ReviewQuoteInstallationOption
            key={installationOption.installationOptionId}
            installationOption={installationOption}
            msrpClassNames={msrpClassNames}
            dNetClassNames={dNetClassNames}
            selectedPriceMode={selectedPriceMode}
            isoCurrencySymbol={isoCurrencySymbol}
          />
        ))}
        {installationTravelInstance}
      </tbody>
    </table>
  );
};

export default class ReviewQuoteInstallation extends React.PureComponent {
  static propTypes = {
    quote: PropTypes.instanceOf(Quote).isRequired,
    onInstallationUpdate: PropTypes.func.isRequired,
    msrpClassNames: PropTypes.string.isRequired,
    dNetClassNames: PropTypes.string.isRequired,
    selectedPriceMode: PropTypes.string.isRequired,
    isoCurrencySymbol: PropTypes.string.isRequired,
  };

  getTravelInstanceComponent() {
    const { installation, installationInformation } = this.props.quote;

    return (
      <ReviewQuoteInstallationTravel
        priceZoneId={installationInformation.priceZoneId}
        dealerGroupId={installationInformation.dealerGroupId}
        basePlantLocation={installationInformation.basePlantLocation}
        locations={installationInformation.installationLocations}
        installation={installation}
        onInstallationUpdate={this.updateInstallation}
        msrpClassNames={this.props.msrpClassNames}
        dNetClassNames={this.props.dNetClassNames}
        isoCurrencySymbol={this.props.isoCurrencySymbol}
      />
    );
  }

  updateInstallation = (updated) => {
    this.props.onInstallationUpdate(new QuoteInstallation(updated));
  };

  render() {
    const {
      quote,
      msrpClassNames,
      dNetClassNames,
      selectedPriceMode,
      isoCurrencySymbol,
    } = this.props;
    const { installation, installationSummaryEntries, supportsInstallation } =
      quote;
    if (!supportsInstallation) return null;
    const noInstallationOptions = installationSummaryEntries.length === 0;

    return (
      <div className="card-deck">
        <div className="card mb-4 box-shadow">
          <div className="card-body">
            <h6 className="card-title text-center">Installation</h6>
            <NoOptions show={noInstallationOptions} />
            {!noInstallationOptions && (
              <React.Fragment>
                <div className="row align-items-center">
                  <div className="col mb-3">
                    <FormToggle
                      checked={installation.included}
                      label="Include installation?"
                      onChange={(included) =>
                        this.updateInstallation(
                          installation.clone().setIncluded(included)
                        )
                      }
                    />
                  </div>
                </div>
                <InstallationOptionsTable
                  installationOptions={installationSummaryEntries}
                  readOnly={!installation.included}
                  installationTravelInstance={
                    installation.included && this.getTravelInstanceComponent()
                  }
                  msrpClassNames={msrpClassNames}
                  dNetClassNames={dNetClassNames}
                  selectedPriceMode={selectedPriceMode}
                  isoCurrencySymbol={isoCurrencySymbol}
                />
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }
}
